import React from "react";
import {
  Body,
  GutterContainer,
  Spacer,
  List,
  Button,
  Keyline,
  Title,
  LinkText
} from "@common/AggregationComponent";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { CombinedReducersType } from "@type/index";
import {
  getRegionFromUrl,
  getBrand,
  isSP,
  getEcRenewalCompatibility
} from "@util/common";
import { ReplacePlaceholderByJSX } from "@util/handleLid";
// import store from "../../../redux/store";
import { FeedbackActions } from "../../../redux/reducer";

const NoResult = (): any => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const storeData = useSelector((state: CombinedReducersType) => state);

  const handleClickSendBtn = () => {
    const formData = new FormData();
    formData.append("image_file", storeData.feedback.image_file);
    formData.append(
      "visual_search_result",
      JSON.stringify(storeData.feedback.visualSearchReqResult)
    );
    formData.append("products_result", "");
    formData.append(
      "data_time",
      JSON.stringify(storeData.imageSearch.image?.lastModified)
    );
    dispatch(FeedbackActions.sendUploadedImage(formData));
  };

  const handleClickTermsOfUse = (): string => {
    const brand = getBrand().toLocaleLowerCase();
    const region = getRegionFromUrl();
    let str = "";
    if (brand === "gu" && region === "jp") {
      str = "https://faq.gu-global.com/articles/FAQ/100001768";
    } else if (brand === "uq" && region === "jp") {
      str = "https://faq.uniqlo.com/articles/FAQ/terms";
    } else if (brand === "uq" && region === "us") {
      str = "https://faq-us.uniqlo.com/articles/en_US/FAQ/Terms-Conditions";
    }
    return str;
  };
  return (
    <GutterContainer>
      <Body element="p" variant="standard">
        {t("text_nosearchresult")}
      </Body>
      <Spacer element="div" variant={"spacing-04"} />
      <Body element="p" variant="standard">
        {t("text_image_search_search_tips")}
      </Body>
      <Spacer element="div" variant={"spacing-02"} />
      <List element="ul" variant="primary">
        <li>
          <Body element="p" variant="standard">
            {t("text_image_search_no_search_result_tips01")}
          </Body>
        </li>
        <li>
          <Body element="p" variant="standard">
            {t("text_image_search_no_search_result_tips02")}
          </Body>
        </li>
        <li>
          <Body element="p" variant="standard">
            {t("text_image_search_no_search_result_tips03")}
          </Body>
        </li>
      </List>

      <Spacer element="div" variant={"spacing-05"} />
      <Keyline className="fr-ec-mb-spacing-05" />
      <Title element="h1" variant="standard">
        {t("text_image_search_no_result_request_to_send_uploaded_image")}
      </Title>
      <Spacer element="div" variant={"spacing-03"} />
      <Body element="p" variant="standard">
        {t(
          "text_image_search_no_result_request_to_send_uploaded_image_description"
        )}
      </Body>
      <Spacer element="div" variant={"spacing-04"} />
      <List element="ul" variant="primary">
        <Spacer element="div" variant={"spacing-02"} />
        <li>
          <Body element="p" variant="standard">
            {t("text_image_search_no_result_check_uploaded_image")}
          </Body>
        </li>
        <li>
          <Body variant="standard" element="p">
            {ReplacePlaceholderByJSX({
              value: t("text_image_search_no_result_terms_of_use"),
              options: {
                text_termsof_conditions: (
                  <LinkText
                    element="a"
                    variant="standalone-primary"
                    href={handleClickTermsOfUse()}
                    emphasize={false}
                    target="_self"
                    ecRenewal={getEcRenewalCompatibility()}
                  >
                    {t("text_termsof_conditions")}
                  </LinkText>
                )
              }
            })}
          </Body>
        </li>
      </List>
      <Spacer element="div" variant={"spacing-06"} />
      <Button
        disabled={storeData.feedback.isUploadedImageSuccess}
        element="button"
        variant="secondary"
        width={isSP() ? "fullWidth" : "halfWidth"}
        textTransform={"normal"}
        onClick={() => {
          handleClickSendBtn();
        }}
        ecRenewal={getEcRenewalCompatibility()}
      >
        {t("text_image_search_no_result_send_uploaded_image")}
      </Button>
    </GutterContainer>
  );
};

export default NoResult;
